import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import { useRef } from "react";

export default function ServerAutoCompleteSearch({
    value,
    options,
    onChange,
    label,
    inputValue,
    onInputChangeSync,
    onInputChange,
    isOptionEqualToValue,
    loading,
    error,
    getOptionLabel,
    hasNextPage,
    onLoadMore,
    required,
    ...props }) {

    const timerRef = useRef(null)

    const onInputChangeHandler = (value) => {
        if (!!timerRef.current) {
            clearTimeout(timerRef.current)
        }
        timerRef.current = setTimeout(() => {
            onInputChange(value)
        }, 1000);
    }

    const listboxRef = useRef(null);


    const handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        if (scrollTop + clientHeight >= scrollHeight - 10 && hasNextPage && !loading) {
            console.log("load more")
            onLoadMore();
        }
    };

    return (
        <Autocomplete
            fullWidth
            size="small"
            value={value}
            options={options}
            isOptionEqualToValue={isOptionEqualToValue}
            inputValue={inputValue}
            // Disable client-side filtering; let the server decide which options to return
            filterOptions={(x) => x}
            clearOnBlur={false}
            onInputChange={(event, text, reason) => {
                // When input is explicitly cleared (by X icon), reset the server list
                if (reason === 'clear') {
                    if (!!timerRef.current) {
                        clearTimeout(timerRef.current)
                    }
                    onInputChange('')
                    if (!!onInputChangeSync) {
                        onInputChangeSync('')
                    }
                    return
                }

                // Selecting an option triggers reason === 'reset'.
                // Don't trigger server reset/fetch here to avoid clearing selected chips in multiple mode.
                if (reason === 'reset') {
                    if (!!onInputChangeSync) {
                        onInputChangeSync(text ?? '')
                    }
                    return
                }

                if (event?.type === 'change') {
                    onInputChangeHandler(text)
                    if (!!onInputChangeSync) {
                        onInputChangeSync(text)
                    }
                }
            }}
            onChange={(_, newValue) => {
                onChange(newValue)
            }}
            loading={loading}
            getOptionLabel={getOptionLabel}
            ListboxProps={{
                ref: listboxRef,
                onScroll: handleScroll
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    // margin="dense"
                    label={label}
                    error={!!error}
                    helperText={error ?? ''}
                    required={required}
                />
            )}
            loadingText={
                loading &&
                <Box display="flex" justifyContent="center" alignItems="center" padding={2}>
                    <CircularProgress size={24} />
                </Box>
            }
            {...props}
        />
    )
}
